<template>
  <v-form class="e-form" v-model="isValid" ref="formRef" @submit.prevent="submit">
    <slot />
  </v-form>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { elementErrorSelector } from '@/core/consts/components';
import { isElementInViewport } from '@/core/utils/dom';
import { sleep } from '@/core/utils/sleep';

defineSlots<{
  default: () => void;
}>();

const emit = defineEmits<{
  (event: 'submit'): void;
}>();

const isValid = defineModel<boolean>();
const isDirty = ref(false);

const formRef = ref();

const validate = async () => {
  if (!formRef.value) {
    return false;
  }

  isDirty.value = true;

  let { valid } = await formRef.value.validate();

  await sleep(0);

  const errorEl = formRef.value.$el.querySelector(elementErrorSelector);

  if (errorEl) {
    if (!isElementInViewport(errorEl)) {
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }

    valid = false;
  }

  return valid;
};

const submit = async () => {
  if (!formRef.value) {
    return false;
  }

  const isValid = await validate();

  if (!isValid) {
    return false;
  }

  emit('submit');

  return isValid.value;
};

defineExpose({
  submit,
  validate,
  isDirty,
});
</script>

<style scoped lang="scss"></style>
